var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import { ProductQuantitySelector } from "./ProductQuantitySelector";
import Group from "./Group";
import Product from "./Product";
import ProductContextVariable from "../ContextVariable/ProductContextVariable";
var GroupItem = /** @class */ (function (_super) {
    __extends(GroupItem, _super);
    function GroupItem(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.productUid = null;
        _this.quantitySelector = new ProductQuantitySelector();
        _this.overCost = 0;
        _this.overCostWithTax = 0;
        _this.groups = [];
        _this.onSale = true;
        _this.visible = true;
        _this.position = 0;
        _this.contextVariables = null;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        GroupItem.buildFromJson(_this, obj);
        return _this;
    }
    GroupItem.buildFromJson = function (instance, json) {
        if (typeof json === 'object') {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'groups' && json[prop].length > 0) {
                        for (var _i = 0, _a = json[prop]; _i < _a.length; _i++) {
                            var subProp = _a[_i];
                            instance.groups.push(new Group(subProp));
                        }
                    }
                    else if (prop === 'minQuantity') {
                        instance['_minQuantity'] = json[prop];
                    }
                    else if (prop === 'quantitySelector') {
                        instance['quantitySelector'] = new ProductQuantitySelector(json[prop]);
                    }
                    else if (prop === 'maxQuantity') {
                        instance['_maxQuantity'] = json[prop];
                    }
                    else if (prop === 'overCost') {
                        instance['overCost'] = json[prop];
                    }
                    else if (prop === 'overCostWithTax') {
                        instance['overCostWithTax'] = json[prop];
                    }
                    else if (prop === 'contextVariables') {
                        if (json[prop]) {
                            instance.contextVariables = [];
                            for (var subProp in json[prop]) {
                                instance.contextVariables.push(new ProductContextVariable(json[prop][subProp]));
                            }
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
            if (instance.name === null) {
                //TODO : reconstruire avec le nom pour que ce soit plus simple.
                console.log("le nom de l'item n'a pas été récupéré !");
            }
        }
    };
    GroupItem.prototype.exportToJson = function () {
        var JSONGroupItem = {};
        JSONGroupItem['uid'] = this.uid;
        JSONGroupItem['productUid'] = this.productUid;
        JSONGroupItem['overCost'] = this.overCost;
        JSONGroupItem['overCostWithTax'] = this.overCostWithTax;
        JSONGroupItem['position'] = this.position;
        JSONGroupItem['onSale'] = this.onSale;
        JSONGroupItem['visible'] = this.visible;
        JSONGroupItem['quantitySelector'] = this.quantitySelector.exportToJson();
        JSONGroupItem['groups'] = [];
        if (this.groups.length > 0) {
            for (var group in this.groups) {
                JSONGroupItem['groups'].push(this.groups[group].exportToJson());
            }
        }
        JSONGroupItem['contextVariables'] = null;
        if (this.contextVariables !== null) {
            JSONGroupItem['contextVariables'] = [];
            for (var _i = 0, _a = this.contextVariables; _i < _a.length; _i++) {
                var context_1 = _a[_i];
                JSONGroupItem['contextVariables'].push(context_1.exportToJson());
            }
        }
        return JSONGroupItem;
    };
    GroupItem.prototype.get_max_fabricable_unities = function (products) {
        if (this.groups.length === 0) {
            return this.get_max_productable_unity_of_this_groupItem_without_considere_child(products);
        }
        var min = this.get_max_productable_unity_of_this_groupItem_without_considere_child(products);
        for (var _i = 0, _a = this.groups; _i < _a.length; _i++) {
            var group = _a[_i];
            var maxProductable = group.get_max_fabricable_unities(products);
            if (maxProductable !== null && (min === null || maxProductable < min)) {
                min = maxProductable;
            }
        }
        if (min === null) {
            return null;
        }
        else {
            return Math.floor(min / this.quantitySelector.minQuantity);
        }
    };
    GroupItem.prototype.get_max_productable_unity_of_this_groupItem_without_considere_child = function (products) {
        if (this.productUid !== null) {
            // Pour récupérer le stock du produit dans le groupItem
            var product = Product.getCorrespondingProduct(this.productUid, products);
            if (product) {
                var maxProductable = product.get_max_fabricable_unities(products, false);
                if (maxProductable === null || this.quantitySelector.minQuantity === 0) {
                    return null;
                }
                else {
                    return Math.floor(maxProductable / this.quantitySelector.minQuantity);
                }
            }
        }
        return null;
    };
    GroupItem.prototype.getGroupItem = function (groupItemUid) {
        function isInThisGroupItem(uid, groupItem) {
            if (groupItem.uid === uid) {
                return groupItem;
            }
            else {
                var groupItemTmp = null;
                if (groupItem.groups.length > 0) {
                    for (var _i = 0, _a = groupItem.groups; _i < _a.length; _i++) {
                        var group = _a[_i];
                        groupItemTmp = searchInGroup(uid, group);
                        /**If node is find, loop stops, otherwise, it will send the last occurrence**/
                        if (groupItemTmp !== null) {
                            break;
                        }
                    }
                }
                return groupItemTmp;
            }
        }
        function searchInGroup(uid, group) {
            var groupItemTmp = null;
            for (var _i = 0, _a = group.groupItems; _i < _a.length; _i++) {
                var groupItem = _a[_i];
                groupItemTmp = isInThisGroupItem(uid, groupItem);
                if (groupItemTmp !== null) {
                    break;
                }
            }
            return groupItemTmp;
        }
        for (var _i = 0, _a = this.groups; _i < _a.length; _i++) {
            var group = _a[_i];
            var groupItem = searchInGroup(groupItemUid, group);
            if (groupItem !== null) {
                return { groupItem: groupItem, group: group };
            }
        }
        return null;
    };
    return GroupItem;
}(Model));
export default GroupItem;
//# sourceMappingURL=GroupItem.js.map